import { LoginService } from "../domain/services/loginService";

export class Login {
  constructor(private loginService: LoginService) {}

  public async execute(
    tipoDocumento: string,
    user: string,
    password: string,
    recordarme: boolean
  ): Promise<string> {
    const tokenLogin: string = await this.loginService.login(
      tipoDocumento,
      user,
      password,
      recordarme
    );
    return tokenLogin;
  }
}
